import React, { useState, useEffect } from 'react';
import './scss/style.scss';
import './css/style.css';
import './css/header.css';
import './css/login.css';
import './css/custom.css';
//import './config/bootstrap.scss';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from 'react-bootstrap';


/** pages */
import Login from './pages/login/index';
import Recover from './pages/login/recover';
import Reset from './pages/login/reset';
import Logout from './pages/user/logout';
import NotFound from './pages/not_found';
import License from './pages/license';
import PrivacyCandidati from './pages/privacy-candidati';
import { CandidatePrivacyProvider } from './components/CandidatePrivacyModal';
import Home from './pages/index';




/** core & components */
import { LanguageProvider } from './core/language-provider';
import { LoginManager } from './core/login-manager';
import { DataManager } from './core/data-manager';
import HeaderBlock from './components/BodyElements/HeaderBlock';
import FooterBlock from './components/BodyElements/FooterBlock';



import { Helmet } from "react-helmet";
import { settings } from './config/settings';
import Register from './pages/registrati';
import Profile from './pages/profile';
import ProfileSettings from './pages/profile/settings';
import JobDetail from './pages/job-detail';
import JobApply from './pages/job-apply';
import JobApplyReview from './pages/job-apply/review';
import JobExplore from './pages/job-explore';





function App() {

    library.add(fas)

    const [isLogged, setIsLogged] = useState(null);
    const [language, setLanguage] = useState(() => {
        try { return localStorage.getItem('lang') || 'ita'; } catch { return 'ita'; }
    });
    const [userInfo, setUserInfo] = useState(null);


    useEffect(() => {
        async function init() {
            var response = await LoginManager.checkLogin()
            console.log('checkLogin', response)
            setIsLogged(response)
            setUserInfo(LoginManager.getUserInfo());
        }

        init()
        detectSidChange()
    }, []);

    async function detectSidChange() {
        var sessionId = LoginManager.registerChangeSid(async function () {
            var response = await LoginManager.checkLogin()
            console.log('CheckLogin after sid changed', response)
            setIsLogged(response);
            setUserInfo(LoginManager.getUserInfo());
        })
        console.log('--- SESSION ID ' + sessionId + ' ---')
    }


    useEffect(() => {
        // Keep persistence in sync when language changes elsewhere
        try { localStorage.setItem('lang', language); } catch {}
        LanguageProvider.setCurrentLanguage(language);
    }, [language]);

    // Ensure localStorage is updated before the render triggered by language change
    const handleChangeLanguage = (nextLang) => {
        try { localStorage.setItem('lang', nextLang); } catch {}
        LanguageProvider.setCurrentLanguage(nextLang);
        setLanguage(nextLang);
    };


    function AppBody() {
        const location = useLocation();
        const compactRoutes = ['/recover'];
        const isCompact = compactRoutes.includes(location.pathname);

        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{settings.title}</title>
                    <meta name="description" content="React application" />
                </Helmet>
                <Container fluid id="main-container" className=' px-0'>
                    <HeaderBlock language={language} onChangeLanguage={handleChangeLanguage} />
                    <div id='app-container' className={isCompact ? 'app-container-compact' : ''}>
                        <Routes>
                            <Route path="*" element={<NotFound />} /> {/* 404 page */}
                            <Route exact path='/' element={<JobExplore />} /> {/* default page */}
                            <Route path='/license' element={<License />} />
                            <Route path='/privacy-candidati' element={<PrivacyCandidati />} />
                            <Route path='/logout' element={<Logout />} />
                            <Route path='/recover' element={<Recover />} />
                            <Route path='/profile' element={<Profile />} />
                            <Route path='/profile/settings' element={<ProfileSettings />} />
                            <Route path='/login' element={<Login />} />
                            <Route path='/register' element={<Register />} />
                            <Route path='/job/:k'  element={<JobDetail/>} />
                            <Route path='/job/:k/apply' element={<JobApply />} />
                            <Route path='/job/:k/apply/review' element={<JobApplyReview />} />
                        </Routes>
                    </div>
                    <FooterBlock />
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                </Container>
            </>
        );
    }

    return (
        <CandidatePrivacyProvider>
            <Router basename={'/'}>
                <AppBody />
            </Router>
        </CandidatePrivacyProvider>
    );
}

export default App;
